/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

// Mirror interactions between collection sorting on desktop (custom, not attached to Pipeline sort class) and mobile (Pipeline default)
function collectionSorting() {
    if (document.body.classList.contains("template-collection")) {
        const $label = document.querySelector(
            ".sb-collection-sort-desktop [data-sort-button-text]",
        );
        const $items = document.querySelectorAll(
            ".sb-collection-sort-desktop .popout-list__item",
        );
        const $trueSort = document.querySelector(
            ".collection__nav .collection__sort",
        );
        const $trueLabel = $trueSort.querySelector("[data-sort-button-text]");

        $items.forEach(function ($i) {
            const $option = $i.querySelector(".popout-list__option");
            $option.addEventListener("click", function (e) {
                e.preventDefault();
                const val = this.getAttribute("data-value");
                const $trueOpt = $trueSort.querySelector(
                    '.popout-list__option[data-value="' + val + '"]',
                );
                $trueOpt.click();
                $label.innerText = $trueLabel.innerText;
                $items.forEach(function ($i2) {
                    $i2.classList.remove("popout-list__item--current");
                });
                $i.classList.add("popout-list__item--current");
            });
        });
    }
}

(function () {
    // init
    collectionSorting();

    $(".model-product-toggle__wrapper button").click(function (e) {
        e.preventDefault();

        $(".model-product-toggle__wrapper button").removeClass("active");
        $(this).addClass("active");

        if ($(this).hasClass("model-btn")) {
            $(".modeled-media__wrapper").addClass("active");
            $(".modeled-media__wrapper").removeClass("inactive");
            $(".product-media__wrapper").addClass("inactive");
            $(".product-media__wrapper").removeClass("active");
        } else {
            $(".product-media__wrapper").addClass("active");
            $(".product-media__wrapper").removeClass("inactive");
            $(".modeled-media__wrapper").addClass("inactive");
            $(".modeled-media__wrapper").removeClass("active");
        }
    });
})();

$(document).ready(function () {
    var termsSelector = 'input[name="attributes[terms_of_service]"]';
    var privacySelector = 'input[name="attributes[privacy_policy]"]';

    function checkCheckboxes(form) {
        var $form = $(form);
        var termsChecked = $form.find(termsSelector).is(":checked");
        var privacyChecked = $form.find(privacySelector).is(":checked");
        var $button = $form.find(".checkout__button");

        if (termsChecked && privacyChecked) {
            $button.removeClass("disabled").removeAttr("disabled");
        } else {
            $button.addClass("disabled").attr("disabled", "disabled");
        }
    }

    $(termsSelector)
        .closest("form")
        .each(function () {
            checkCheckboxes(this);
        });

    $(document).on(
        "change",
        termsSelector + ", " + privacySelector,
        function () {
            checkCheckboxes(this.form);
        },
    );

    $(".swatch__button label").on("click", function () {
        let choice = $(this).attr("data-swatch").toLowerCase();
        // console.log("choice -->", choice);
        $(".product_thumbnails-grid .product__media")
            .find("img")
            .each(function () {
                let alt = $(this).attr("alt").toLowerCase();
                if (alt.includes(choice)) {
                    //console.log("alt -->", alt);
                    $(this).closest(".swiper-slide").show();
                    $(this).closest(".swiper-slide").css("width", "");
                } else {
                    $(this).closest(".swiper-slide").hide();
                }
            });
    });
});

document.addEventListener("DOMContentLoaded", () => {
    // move popup to body (safer z-index)
    const popup = document.querySelector(".real-video-popup");
    if (popup) document.body.appendChild(popup);

    const popupBox = popup?.querySelector(".real-video-add");
    const closeBtn = popup?.querySelector(".close-button");
    let currentVideoEl = null;

    // click each thumbnail/card
    document.querySelectorAll(".real-result-image").forEach((card) => {
        card.addEventListener("click", (e) => {
            e.preventDefault();
            const videoHolder = card.querySelector(".video-tag");
            if (!videoHolder || !popupBox) return;

            // if already playing this one -> close it
            if (card.classList.contains("played")) {
                popup.classList.remove("open");
                if (currentVideoEl) {
                    currentVideoEl.pause();
                    currentVideoEl.currentTime = 0;
                }
                popupBox.innerHTML = "";
                currentVideoEl = null;
                card.classList.remove("played");
                return;
            }

            // stop previous
            if (currentVideoEl) {
                currentVideoEl.pause();
                currentVideoEl.currentTime = 0;
            }
            document
                .querySelectorAll(".real-result-image.played")
                .forEach((el) => el.classList.remove("played"));

            // inject this video's HTML into popup
            popupBox.innerHTML = videoHolder.innerHTML;

            // open + play
            popup.classList.add("open");
            currentVideoEl = popupBox.querySelector("video");
            if (currentVideoEl) currentVideoEl.play();

            // mark this card as active
            card.classList.add("played");
        });
    });

    // close popup
    closeBtn?.addEventListener("click", () => {
        popup.classList.remove("open");

        if (currentVideoEl) {
            currentVideoEl.pause();
            currentVideoEl.currentTime = 0;
            currentVideoEl = null;
        }

        popupBox.innerHTML = "";
        document
            .querySelectorAll(".real-result-image.played")
            .forEach((el) => el.classList.remove("played"));
    });
});

// Cart upsell

document.addEventListener("DOMContentLoaded", function () {
    loadCartDrawerRecommendations();
});

document.addEventListener("cart:updated", function () {
    loadCartDrawerRecommendations();
});

function formattingMoney(money) {
    const value = money / 100;
    let formatted = "";

    if (theme.moneyFormat.includes("{{amount_no_decimals}}")) {
        formatted = Math.round(value).toLocaleString();
    } else if (theme.moneyFormat.includes("{{amount_with_comma_separator}}")) {
        formatted = value.toFixed(2).replace(".", ",");
    } else if (
        theme.moneyFormat.includes(
            "{{amount_no_decimals_with_comma_separator}}",
        )
    ) {
        formatted = Math.round(value).toLocaleString("de-DE");
    } else {
        formatted = value.toFixed(2);
    }

    let moneyString = theme.moneyFormat
        .replace("{{amount}}", formatted)
        .replace("{{amount_no_decimals}}", Math.round(value).toLocaleString())
        .replace(
            "{{amount_with_comma_separator}}",
            value.toFixed(2).replace(".", ","),
        )
        .replace(
            "{{amount_no_decimals_with_comma_separator}}",
            Math.round(value).toLocaleString("de-DE"),
        );

    if (theme.settings.currency_code_enable) {
        moneyString += ` ${theme.currencyCode}`;
    }

    return moneyString;
}

function loadCartDrawerRecommendations() {
    const wrapper = document.querySelector("[data-cart-recommendations]");
    if (!wrapper) return;

    const productId = wrapper.getAttribute("data-product-id");
    const list = wrapper.querySelector("[data-cart-recommendations-list]");
    if (!productId || !list) return;

    fetch(
        `/recommendations/products.json?product_id=${productId}&limit=3&intent=related`,
    )
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            if (!data.products || !data.products.length) {
                wrapper.style.display = "none";
                return;
            }

            wrapper.style.display = "";

            list.innerHTML = data.products
                .slice(0, 3)
                .map(function (product) {
                    const image = product.featured_image
                        ? product.featured_image
                        : "";

                    const price = formattingMoney(product.price);

                    const variantId =
                        product.variants && product.variants.length
                            ? product.variants[0].id
                            : "";

                    const productUrl = product.url || "#";
                    console.log("hellooooo", product.featured_image);

                    return `
          <div class="cart-drawer-recommendation-item">
            <div class="cart-drawer-recommendation-box">
              <a href="${productUrl}" class="cart-drawer-recommendation-item__image">
                ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : ""}
              </a>

              <div class="cart-drawer-recommendation-item__content">
                <div class="cart-drawer-recommendation-text">
                  <h4 class="cart-drawer-recommendation-item__title">
                    <a href="${productUrl}">${product.title}</a>
                  </h4>
                  <div class="cart-drawer-recommendation-item__price">
                    ${price}
                  </div>
                </div>
               
              </div>

              
            </div>
          </div>
        `;
                })
                .join("");

            bindRecommendationAddToCart();
        })
        .catch(function (error) {
            console.error("Recommendation error:", error);
            wrapper.style.display = "none";
        });
}

function bindRecommendationAddToCart() {
    const buttons = document.querySelectorAll("[data-add-recommendation]");

    buttons.forEach(function (button) {
        button.removeEventListener("click", handleRecommendationAdd);
        button.addEventListener("click", handleRecommendationAdd);
    });
}

function handleRecommendationAdd(event) {
    const button = event.currentTarget;
    const variantId = button.getAttribute("data-variant-id");

    if (!variantId) return;

    button.disabled = true;
    button.textContent = "ADDING...";

    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            id: variantId,
            quantity: 1,
        }),
    })
        .then(function (response) {
            if (!response.ok) {
                throw new Error("Failed to add product");
            }
            return response.json();
        })
        .then(function () {
            button.textContent = "ADDED";

            document.dispatchEvent(new CustomEvent("cart:updated"));
        })
        .catch(function (error) {
            console.error("Add to cart error:", error);
            button.disabled = false;
            button.textContent = "+ADD";
        });
}
